import { Injectable } from '@angular/core';

@Injectable()
export class RegexService{
    readonly passwordRegex: string = '(?=.*[a-z])(?=.*[A-Z])(?=.*?[^\\w\\s]).{8,}$';
}